var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges } from '@angular/core';
import { HubPlace } from 'models/hub/hub.place';
import { VisitorApiService } from "../../../../services/visitor.api.service";
var NearbyPlacesComponent = /** @class */ (function () {
    function NearbyPlacesComponent(visitorApiService) {
        this.visitorApiService = visitorApiService;
        this.allPlaces = [];
        this.isLoadingAllPlaces = false;
        this.paginationIndex = 0;
        this.paginationPageLimit = 5;
        this.nearByPlaces = [];
        this.showingCount = '';
        this.noMoreNext = false;
        this.noMoreBack = true;
        this.onGotoPlace = new EventEmitter();
        this.getDistanceFromLatLng = function (lat1, lon1, lat2, lon2) {
            if (!lat1 || !lon1 || !lat2 || !lon2) {
                return 0;
            }
            var R = 6371; // Radius of the earth in km
            var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
            var dLon = this.deg2rad(lon2 - lon1);
            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                    Math.sin(dLon / 2) * Math.sin(dLon / 2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c; // Distance in km
            return d * 1000;
        };
    }
    NearbyPlacesComponent.prototype.ngOnChanges = function () {
        this.loadNearbyPlaces();
    };
    NearbyPlacesComponent.prototype.gotoPlace = function (item) {
        this.onGotoPlace.emit(item);
    };
    NearbyPlacesComponent.prototype.loadNearbyPlaces = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.isLoadingAllPlaces = true;
                this.visitorApiService.getNearByPlaces(this.currentPlace, this.source).subscribe(function (data) {
                    _this.pagination(data);
                });
                return [2 /*return*/];
            });
        });
    };
    NearbyPlacesComponent.prototype.pagingBack = function () {
        if (this.noMoreBack) {
            return;
        }
        this.paginationIndex--;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (start <= 0) {
            start = 0;
            this.noMoreBack = true;
        }
        this.nearByPlaces = this.allPlaces.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreNext = false;
    };
    NearbyPlacesComponent.prototype.pagingNext = function () {
        if (this.noMoreNext) {
            return;
        }
        this.paginationIndex++;
        var start = this.paginationPageLimit * this.paginationIndex;
        var end = start + this.paginationPageLimit;
        if (end >= this.allPlaces.length) {
            end = this.allPlaces.length;
            this.noMoreNext = true;
        }
        this.nearByPlaces = this.allPlaces.slice(start, end);
        this.showingCount = start + 1 + " - " + end;
        this.noMoreBack = false;
    };
    NearbyPlacesComponent.prototype.pagination = function (allPlacesWithCurrent) {
        var _this = this;
        this.allPlaces = allPlacesWithCurrent.filter(function (x) { return x._id !== _this.currentPlace._id; });
        this.sortPlacesByDistance();
        this.paginationIndex = 0;
        var placesInThisPage = [];
        if (this.allPlaces.length > this.paginationPageLimit) {
            var max = this.paginationPageLimit * (this.paginationIndex + 1);
            placesInThisPage = this.allPlaces.slice(0, max);
            this.showingCount = this.paginationPageLimit * this.paginationIndex + 1 + " - " + max;
            this.noMoreNext = false;
            this.noMoreBack = true;
        }
        else {
            placesInThisPage = allPlacesWithCurrent;
            this.noMoreNext = true;
            this.noMoreBack = true;
        }
        this.visitorApiService.convertGoogleImages(this.currentPlace.hubName, placesInThisPage).subscribe(function (converted) {
            console.log(converted.map(function (x) { return x.cover ? x.cover.source : ''; }));
            _this.nearByPlaces = converted;
            _this.isLoadingAllPlaces = false;
        });
    };
    NearbyPlacesComponent.prototype.getPlaces = function () {
        return this.visitorApiService.getPlaces(this.currentPlace.hubName, {
            page: 1,
            limit: 500,
            category: 'All',
            source: this.source
        });
    };
    NearbyPlacesComponent.prototype.sortPlacesByDistance = function () {
        var _this = this;
        this.allPlaces.forEach(function (x) {
            var distance = _this.getDistanceFromLatLng(_this.currentPlace.address.lat, _this.currentPlace.address.lng, x.address.lat, x.address.lng);
            x['distance'] = distance;
        });
        this.allPlaces.sortBy(function (x) { return x.distance; });
    };
    NearbyPlacesComponent.prototype.deg2rad = function (deg) {
        return deg * (Math.PI / 180);
    };
    return NearbyPlacesComponent;
}());
export { NearbyPlacesComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/place.details.modal/nearby.places.component/nearby.places.component.ts.pre-build-optimizer.js